<!--
 * @Description: 抽屉-新建/修改
 * @Author: hasayake
 * @Date: 2020-05-08 11:10:43
 * @LastEditTime: 2020-07-02 10:38:08
 * @LastEditors: Please set LastEditors
-->

<template>
  <el-drawer
    :with-header="false"
    title=""
    size="20%"
    :visible.sync="value"
    :before-close="handleClose">
      <div class="drawer__wrapper">
        <el-form :rules="rules" :model="form" ref="form">
          <el-form-item label="" prop="dirName">
            <el-input
              v-model="form.dirName" placeholder="请输入文件夹名称">
            </el-input>
          </el-form-item>
        </el-form>

        <el-button
          size="small" type="primary"
          @click="saveHandler" :disabled="!form.dirName">
            保存
        </el-button>
      </div>
  </el-drawer>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    value(val) {
      if (!val) {
        this.form.dirName = ''
      }
    }
  },

  data() {
    const dirNameValidate = (rule, value, cb) => {
      if (!value) {
        cb(new Error('请输入文件夹名'))
      } else {
        console.log((/\S/.test(value)))
        if (!(/\S/.test(value))) {
          cb(new Error('文件夹名不能只存在空白字符...'))
        }
      }

      cb()
    }

    return {
      form: {
        dirName: '',
      },
      rules: {
        dirName: [
          { required: true,  validator: dirNameValidate }
        ]
      }
    }
  },

  methods: {
    handleClose() {
      this.$emit('input', false)
    },
    saveHandler() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('save', this.form.dirName)
        } else {
          return false
        }
      })

    }
  }
}
</script>

<style lang="scss" scoped>
.drawer__wrapper {
  padding: 40px 20px;
  text-align: right;

  button {
    margin-top: 20px;
  }
}
</style>